import React from 'react'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { change as changeFieldValue, formValueSelector, reduxForm } from 'redux-form';
import { showSuccessMsg, showAlertMsg } from '../../util/messagesUtil';
import cadastrarRegraControleEmissaoBpe from '../../actions/bpe/cadastrarRegraControleEmissaoBpe';
import buscarEmpresaPorId from '../../actions/empresa/buscarEmpresaPorId';
import cadastrarControleEmissaoBpeUsuario from '../../actions/bpe/cadastrarControleEmissaoBpeUsuario';
import buscarUsuarioPorEmpresaNomeIdEmail from '../../actions/usuario/buscarUsuarioEmpresaPorParte';
import { tipoControleEmissaoBPe } from '../../util/constantsUtil';
import Select from 'react-select';
import $ from 'jquery';
import ReactTooltip from 'react-tooltip';

export class ModalPainelRegraControleEmissaoBpe extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      usuarioEmpresaSelecionado: null,
      tiposPagamentoSelecionados: [],
      usuarios: [],
      carregandoUsuarios: false
    };
    this.submit = this.submit.bind(this);
    this.limparFormulario = this.limparFormulario.bind(this);
    this.handleUsuarioChange = this.handleUsuarioChange.bind(this);
    this.handleTipoPagamentoChange = this.handleTipoPagamentoChange.bind(this);
    this.buscarUsuarios = this.buscarUsuarios.bind(this);
  }

  limparFormulario() {
    this.props.reset('formularioPainelRegraControleEmissaoBpe');
    this.setState({
      usuarioEmpresaSelecionado: null,
      tiposPagamentoSelecionados: [],
      usuarios: []
    });
  }

  limparCampos() {
    this.props.limparCheckedTipoControle();
    this.setState({
      usuarioEmpresaSelecionado: null,
      tiposPagamentoSelecionados: [],
      usuarios: []
    });
  }

  buscarUsuarios(inputValue) {
    if (!inputValue || inputValue.length < 2) {
      this.setState({ usuarios: [] });
      return;
    }

    const empresaId = this.props.codigoEmpresaSelecionada;
    if (!empresaId) {
      return;
    }

    this.setState({ carregandoUsuarios: true });
    this.props.buscarUsuarioPorEmpresaNomeIdEmail(inputValue, empresaId)
      .then(response => {
        const data = response.payload.data || [];
        const usuarios = Array.isArray(data) ? data.map(ue => {
          const usuarioEmpresaId = ue.usuarioEmpresaId || ue.id;
          return {
            value: usuarioEmpresaId,
            label: `${ue.nome || ''} (${ue.email || ''})`
          };
        }).filter(u => u.value) : [];
        this.setState({ usuarios, carregandoUsuarios: false });
      })
      .catch(() => {
        this.setState({ carregandoUsuarios: false });
      });
  }

  handleUsuarioChange(selectedOption) {
    if (selectedOption && selectedOption.value) {
      this.setState({ usuarioEmpresaSelecionado: selectedOption });
    } else {
      this.setState({ usuarioEmpresaSelecionado: null });
    }
  }

  handleTipoPagamentoChange(tipoPagamento, checked) {
    const tiposPagamento = [...this.state.tiposPagamentoSelecionados];
    if (checked) {
      if (!tiposPagamento.includes(tipoPagamento)) {
        tiposPagamento.push(tipoPagamento);
      }
    } else {
      const index = tiposPagamento.indexOf(tipoPagamento);
      if (index > -1) {
        tiposPagamento.splice(index, 1);
      }
    }
    this.setState({ tiposPagamentoSelecionados: tiposPagamento });
  }

  submit() {
    // Se for POR_USUARIO, validar se tem configuração de usuário
    if (this.props.tipoControleBpeSelecionado === tipoControleEmissaoBPe.porUsuario.value) {
      if (!this.state.usuarioEmpresaSelecionado) {
        showAlertMsg('Selecione um usuário.');
        return;
      }
      if (!this.state.usuarioEmpresaSelecionado.value) {
        showAlertMsg('Selecione um usuário válido. O usuário selecionado não possui ID válido.');
        return;
      }
      if (this.state.tiposPagamentoSelecionados.length === 0) {
        showAlertMsg('Selecione ao menos um tipo de pagamento.');
        return;
      }
    }

    // Salvar regra primeiro
    this.props.cadastrarRegraControleEmissaoBpe(this.montarParametroControle()).then(() => {
      // Se for POR_USUARIO, salvar também a configuração do usuário
      if (this.props.tipoControleBpeSelecionado === tipoControleEmissaoBPe.porUsuario.value) {
        const configUsuario = {
          usuarioEmpresaId: this.state.usuarioEmpresaSelecionado.value,
          tiposPagamento: this.state.tiposPagamentoSelecionados
        };
        return this.props.cadastrarControleEmissaoBpeUsuario(configUsuario).then(() => {
          showSuccessMsg('Regra e configuração de usuário salvas com sucesso');
          this.limparCampos();
          this.props.buscarConfiguracoesBPe();
          this.props.buscarEmpresaPorId(this.props.codigoEmpresaSelecionada);
          this.fecharModal();
        }).catch(error => {
          if (error.response && error.response.data && error.response.data.message) {
            showAlertMsg(error.response.data.message);
          } else {
            showAlertMsg('Erro ao salvar configuração do usuário.');
          }
        });
      } else {
        showSuccessMsg('Regra Controle Emissao Bpe salva com sucesso');
        this.limparCampos();
        this.props.buscarConfiguracoesBPe();
        this.props.buscarEmpresaPorId(this.props.codigoEmpresaSelecionada);
        this.fecharModal();
      }
    });
  }

  fecharModal() {
    $('#modalPainelRegraControleEmissaoBpe')
      .modal('hide');
    $('#modalPainelRegraControleEmissaoBpe')
      .hide();
    $('.modal-backdrop')
      .hide();
    this.limparFormulario();
  }

  montarParametroControle() {
    return {
      idEmpresa: this.props.codigoEmpresaSelecionada,
      tipoControleEmissaoBPe: this.props.tipoControleBpeSelecionado
    };
  }

  exibirIconeAjudaRegra(tipoControle, tooltipId, tooltipContent) {
    return (
      <span className="align-self-center tooltip-info">
        <a data-tip data-for={tooltipId}>
          <i className="material-icons ajuda-icon" style={{ color: '#000' }}>help</i>
        </a>
        <div className="tooltip-ut">
          <ReactTooltip className="tooltip-ut" id={tooltipId} type="dark" effect="solid">
            <div className="row">{tooltipContent}</div>
          </ReactTooltip>
        </div>
      </span>
    );
  }

  render() {
    const { handleSubmit } = this.props;
    return (
      <div className="modal fade show" id='modalPainelRegraControleEmissaoBpe' role='dialog'
        aria-labelledby='modalPainelRegraControleEmissaoBpe' aria-hidden='true' data-backdrop='static'>
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content vx-modal-content">
            <div className="vx-modal-header">
              <div className="vx-modal-header-left">
                <i className="material-icons">tune</i>
                <span className="vx-modal-title">Painel Selecionar Regra Controle Emissão BPe</span>
              </div>
              <button type="button" className="vx-modal-close" data-dismiss="modal"
                onClick={this.limparFormulario}>
                <i className="material-icons">close</i>
              </button>
            </div>
            <form onSubmit={handleSubmit(this.submit)}>
              <div className="vx-modal-body">
                <div className="vx-modal-section">
                  <div className="vx-modal-section-title">
                    <i className="material-icons">settings</i>Tipo de Controle de Emissão BPe
                  </div>
                  <div className='form-group form-check'>
                    <input type="radio" name='tipoContole' style={{ cursor: 'pointer' }}
                      id={tipoControleEmissaoBPe.padrao.value} className='form-check-input'
                      onChange={() => this.props.checkedFieldTipoControle(tipoControleEmissaoBPe.padrao.value)}
                      value={tipoControleEmissaoBPe.padrao.value}
                      checked={this.props.tipoControleBpeSelecionado == tipoControleEmissaoBPe.padrao.value} />
                    <label htmlFor={tipoControleEmissaoBPe.padrao.value} style={{ cursor: 'pointer' }} className='form-check-label'>{tipoControleEmissaoBPe.padrao.label}</label>
                    {this.exibirIconeAjudaRegra(tipoControleEmissaoBPe.padrao.value, 'regraPadrao', 'Configuração original existente, respeitando ativo e inativo empresa e estados.')}
                  </div>
                  <div className='form-group form-check'>
                    <input type="radio" name='tipoContole' style={{ cursor: 'pointer' }}
                      id={tipoControleEmissaoBPe.horario.value} className='form-check-input'
                      onChange={() => this.props.checkedFieldTipoControle(tipoControleEmissaoBPe.horario.value)}
                      value={tipoControleEmissaoBPe.horario.value}
                      checked={this.props.tipoControleBpeSelecionado == tipoControleEmissaoBPe.horario.value} />
                    <label htmlFor={tipoControleEmissaoBPe.horario.value} style={{ cursor: 'pointer' }} className='form-check-label'>{tipoControleEmissaoBPe.horario.label}</label>
                    {this.exibirIconeAjudaRegra(tipoControleEmissaoBPe.horario.value, 'regraHorario', 'Será transmitido somente nos horários marcados na tabela.')}
                  </div>
                  <div className='form-group form-check'>
                    <input type="radio" name='tipoContole' style={{ cursor: 'pointer' }}
                      id={tipoControleEmissaoBPe.cartao.value} className='form-check-input'
                      onChange={() => this.props.checkedFieldTipoControle(tipoControleEmissaoBPe.cartao.value)}
                      value={tipoControleEmissaoBPe.cartao.value}
                      checked={this.props.tipoControleBpeSelecionado == tipoControleEmissaoBPe.cartao.value} />
                    <label htmlFor={tipoControleEmissaoBPe.cartao.value} style={{ cursor: 'pointer' }} className='form-check-label'>{tipoControleEmissaoBPe.cartao.label}</label>
                    {this.exibirIconeAjudaRegra(tipoControleEmissaoBPe.cartao.value, 'regraCartao', 'Transmitir BPe em todas vendas de cartão.')}
                  </div>
                  <div className='form-group form-check'>
                    <input type="radio" name='tipoContole' style={{ cursor: 'pointer' }}
                      id={tipoControleEmissaoBPe.horarioMaisCartao.value} className='form-check-input'
                      onChange={() => this.props.checkedFieldTipoControle(tipoControleEmissaoBPe.horarioMaisCartao.value)}
                      value={tipoControleEmissaoBPe.horarioMaisCartao.value}
                      checked={this.props.tipoControleBpeSelecionado == tipoControleEmissaoBPe.horarioMaisCartao.value} />
                    <label htmlFor={tipoControleEmissaoBPe.horarioMaisCartao.value} style={{ cursor: 'pointer' }} className='form-check-label'>{tipoControleEmissaoBPe.horarioMaisCartao.label}</label>
                    {this.exibirIconeAjudaRegra(tipoControleEmissaoBPe.horarioMaisCartao.value, 'regrahorarioMaisCartao', 'Quando a regra do temporizador estiver ativa, se vender no cartão Independente do horário ela vai transmitir o bpe na venda.')}
                  </div>
                  <div className='form-group form-check'>
                    <input type="radio" name='tipoContole' style={{ cursor: 'pointer' }}
                      id={tipoControleEmissaoBPe.tef.value} className='form-check-input'
                      onChange={() => this.props.checkedFieldTipoControle(tipoControleEmissaoBPe.tef.value)}
                      value={tipoControleEmissaoBPe.tef.value}
                      checked={this.props.tipoControleBpeSelecionado == tipoControleEmissaoBPe.tef.value} />
                    <label htmlFor={tipoControleEmissaoBPe.tef.value} style={{ cursor: 'pointer' }} className='form-check-label'>{tipoControleEmissaoBPe.tef.label}</label>
                    {this.exibirIconeAjudaRegra(tipoControleEmissaoBPe.tef.value, 'regraTef', 'Transmitir BPe em todas vendas de TEF.')}
                  </div>
                  <div className='form-group form-check'>
                    <input type="radio" name='tipoContole' style={{ cursor: 'pointer' }}
                      id={tipoControleEmissaoBPe.porUsuario.value} className='form-check-input'
                      onChange={() => this.props.checkedFieldTipoControle(tipoControleEmissaoBPe.porUsuario.value)}
                      value={tipoControleEmissaoBPe.porUsuario.value}
                      checked={this.props.tipoControleBpeSelecionado == tipoControleEmissaoBPe.porUsuario.value} />
                    <label htmlFor={tipoControleEmissaoBPe.porUsuario.value} style={{ cursor: 'pointer' }} className='form-check-label'>{tipoControleEmissaoBPe.porUsuario.label}</label>
                    {this.exibirIconeAjudaRegra(tipoControleEmissaoBPe.porUsuario.value, 'regraPorUsuario', 'Emite BPE baseado na configuração específica de cada usuário da empresa.')}
                  </div>
                </div>

                {this.props.tipoControleBpeSelecionado === tipoControleEmissaoBPe.porUsuario.value && (
                  <div className="vx-modal-section">
                    <div className="vx-modal-section-title">
                      <i className="material-icons">person</i>Configuração por Usuário
                    </div>
                    <div className="alert alert-info" role="alert">
                      Configure o primeiro usuário e seus tipos de pagamento permitidos.
                    </div>
                    <div className="form-row">
                      <div className="col-12 mb-3">
                        <label>Usuário</label>
                        <Select
                          maxMenuHeight={200}
                          menuPlacement="auto"
                          noOptionsMessage={() => ('Digite pelo menos 2 caracteres para buscar')}
                          placeholder='Digite para buscar usuário...'
                          options={this.state.usuarios}
                          value={this.state.usuarioEmpresaSelecionado}
                          onChange={this.handleUsuarioChange}
                          onInputChange={this.buscarUsuarios}
                          isLoading={this.state.carregandoUsuarios}
                        />
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="col-12 mb-3">
                        <label>Tipos de Pagamento</label>
                        <div className="form-group">
                          <div className="form-check">
                            <input className="form-check-input" type="checkbox" id="tipoPagamento_1"
                              checked={this.state.tiposPagamentoSelecionados.includes(1)}
                              onChange={(e) => this.handleTipoPagamentoChange(1, e.target.checked)} />
                            <label className="form-check-label" htmlFor="tipoPagamento_1">Cartão</label>
                          </div>
                          <div className="form-check">
                            <input className="form-check-input" type="checkbox" id="tipoPagamento_7"
                              checked={this.state.tiposPagamentoSelecionados.includes(7)}
                              onChange={(e) => this.handleTipoPagamentoChange(7, e.target.checked)} />
                            <label className="form-check-label" htmlFor="tipoPagamento_7">PIX</label>
                          </div>
                          <div className="form-check">
                            <input className="form-check-input" type="checkbox" id="tipoPagamento_8"
                              checked={this.state.tiposPagamentoSelecionados.includes(8)}
                              onChange={(e) => this.handleTipoPagamentoChange(8, e.target.checked)} />
                            <label className="form-check-label" htmlFor="tipoPagamento_8">TEF</label>
                          </div>
                          <div className="form-check">
                            <input className="form-check-input" type="checkbox" id="tipoPagamento_3"
                              checked={this.state.tiposPagamentoSelecionados.includes(3)}
                              onChange={(e) => this.handleTipoPagamentoChange(3, e.target.checked)} />
                            <label className="form-check-label" htmlFor="tipoPagamento_3">Dinheiro</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="vx-modal-footer">
                <button type="submit"
                  disabled={!this.props.tipoControleBpeSelecionado}
                  className="vx-btn-primary">
                  <i className="material-icons">save</i>
                  Salvar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export function mapStateToProps(state) {
  const empresaSelecionada = state.empresaSelecionada;
  return {
    tipoControle: formValueSelector('formularioPainelRegraControleEmissaoBpe')(state, 'tipoControle'),
    codigoEmpresaSelecionada: empresaSelecionada?.empresa?.id || empresaSelecionada?.id || null
  }
}

export const mapDispatchToProps = dispatch => (
  bindActionCreators({
    changeFieldValue,
    cadastrarRegraControleEmissaoBpe,
    buscarEmpresaPorId,
    cadastrarControleEmissaoBpeUsuario,
    buscarUsuarioPorEmpresaNomeIdEmail
  }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
  form: 'formularioPainelRegraControleEmissaoBpe'
})(ModalPainelRegraControleEmissaoBpe));